import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DriveEtaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"drive_eta"}/>
}
